import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-complaint',
  standalone: true,
  templateUrl: '../../assets/complaint.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamComplaintIcon {}
